import { render, staticRenderFns } from "./LoginRegisterModal.vue?vue&type=template&id=a1310f50&scoped=true"
import script from "./LoginRegisterModal.vue?vue&type=script&lang=js"
export * from "./LoginRegisterModal.vue?vue&type=script&lang=js"
import style0 from "./LoginRegisterModal.vue?vue&type=style&index=0&id=a1310f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1310f50",
  null
  
)

export default component.exports